<template>
    <div @click="onclickFilter($event);" :style="'background-color:' + info.color + '; border-color: ' + info.color" class="button">
        <span :class="status === -1 ? 'text-dark' : ''">{{ short ? info.label.charAt(0).toUpperCase() : info.label }}</span>
    </div>
</template>
<script>
import { FORECAST_STATUS } from "@/components/forecasts/constants";
import { getStatusColor, getStatusName } from "@/components/forecasts/utils/utilis";

export default {
    props: {
        status: {
            type: Number | String,
            required: true,
            default: null
        },
        short: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        info() {
            if (this.status === "DELETE") {
                return { label: getStatusName(this.status), color: getStatusColor(this.status) };
            } else if (this.status === -1) {
                return { label: "ALL", color: getStatusColor(this.status) };
            } else if (this.status === FORECAST_STATUS.DRAFT) {
                return { label: getStatusName(this.status), color: getStatusColor(this.status) };
            } else if (this.status === FORECAST_STATUS.PENDING) {
                return { label: getStatusName(this.status), color: getStatusColor(this.status) };
            } else if (this.status === FORECAST_STATUS.ACTIVE) {
                return { label: getStatusName(this.status), color: getStatusColor(this.status) };
            } else if (this.status === FORECAST_STATUS.CLOSED) {
                return { label: getStatusName(this.status), color: getStatusColor(this.status) };
            }
            return "unknown status";
        }
    },
    data() {
        return {
            FORECAST_STATUS
        };
    },
    methods: {
        onclickFilter($event) {
            this.$emit("click", $event);
        }
    }
};
</script>
<style scoped lang="scss">
@import "../css/forecasts";

div.button {
    text-align: center;
    width: 110px;
    margin: 5px;
    margin-left: 0;
    padding: 10px 11px;
    border: thin solid;
    cursor: pointer;
    @media (max-width: 1440px) {
        min-width: 90px;
        width: 100%;
    }
    @media (max-width: 768px) {
        width: 100%;
    }
}
span {
    color: $text_secondary_color;
    letter-spacing: 0;
}
</style>



// WEBPACK FOOTER //
// ForecastStatus.vue?58dfb832